import * as React from "react";
import PropTypes from "prop-types";
import { Control, Label, Select } from "rbx";

import { useLazyQuery } from "react-apollo";

import gql from "graphql-tag";

const GET_LOCATION_QUERY = gql`
  query GET_LOCATION_QUERY($where: LocationWhereUniqueInput) {
    Location(where: $where) {
      RecId
      NumberOfLoadingBays
    }
  }
`;

function BayNumberSelect({
  label,
  name,
  value,
  onChange,
  disabled,
  showLabel,
  locationId
}) {
  const [scales, setScales] = React.useState([]);

  const [getLocation, { data: LocationData }] = useLazyQuery(
    GET_LOCATION_QUERY
  );

  React.useEffect(() => {
    if (locationId) {
      getLocation({
        variables: {
          where: {
            RecId: parseInt(locationId, 10)
          }
        },
        fetchPolicy: "cache-and-network"
      });
    }
  }, [getLocation, locationId]);

  React.useEffect(() => {
    const location = LocationData?.Location;
    if (location?.NumberOfLoadingBays) {
      setScales(
        Array.from({ length: location.NumberOfLoadingBays }).map(
          (x, i) => i + 1
        )
      );
    }
  }, [LocationData]);

  const handleChange = e => {
    onChange(e.target.name, e.target.value);
  };

  return (
    <Control expanded>
      {showLabel && <Label>{label}</Label>}
      <Select.Container fullwidth>
        <Select
          disabled={disabled}
          name={name}
          value={value}
          onChange={handleChange}
        >
          <Select.Option value="" />
          {scales.map(scale => (
            <Select.Option
              key={scale}
              value={scale}
            >{`Bay ${scale}`}</Select.Option>
          ))}
        </Select>
      </Select.Container>
    </Control>
  );
}

BayNumberSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  showLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BayNumberSelect.defaultProps = {
  label: "",
  name: "",
  value: "",
  onChange: () => {},
  showLabel: true,
  locationId: "",
  disabled: false
};
export default BayNumberSelect;
